export enum FieldType  {
    Text = 'text',
    Number = 'number',
    Boolean = 'boolean',
    Date = 'date',
    DateTime = 'date-time',
    LastName = 'last-name',
    ActivityBadge = 'activity-badge'
}